import { Alert, Button, Card, ColorSchemeSwitch } from '../shared/components';

import styles from './AuthPages.module.css';

/**
 * Signed in, but not admissible — wrong domain, or an unverified address.
 *
 * The message says what to do next rather than only what went wrong (§14.1).
 * Someone who signed in with a personal Gmail needs to know to use the school
 * account, not that a predicate returned false.
 */
export interface RefusedPageProps {
  readonly messageAr: string;
  readonly onSignOut: () => void;
}

export function RefusedPage({ messageAr, onSignOut }: RefusedPageProps) {
  return (
    <div className={styles.page}>
      <div className={styles.schemeSlot}>
        <ColorSchemeSwitch />
      </div>

      <h1 className="visually-hidden">تعذّر الدخول</h1>

      <Card title="تعذّر الدخول">
        <Alert severity="error">{messageAr}</Alert>

        <p className={styles.body}>
          سجّل الخروج وأعد الدخول بحساب المدرسة الرسمي.
        </p>

        <Button fullWidth onClick={onSignOut}>
          تسجيل الخروج
        </Button>
      </Card>
    </div>
  );
}
